import React, { useMemo } from 'react'
import ReactApexChart from 'react-apexcharts'

const data = [
    {
        "Center Name": "Uttrakhand",
        "total_leads": 100,
        "total_appointments": 80,
        "total_new_patients": 20,
        "total_running_patients": 50,
        "total_completed_patients": 20,
        "total_treated_patients": 10
    },
{        "Center Name": "West Bengal",
        "total_leads": 150,
        "total_appointments": 120,
        "total_new_patients": 30,
        "total_running_patients": 60,
        "total_completed_patients": 30,
        "total_treated_patients": 15
    },
    {
        "Center Name": "Maharashtra",
        "total_leads": 200,
        "total_appointments": 160,
        "total_new_patients": 40,
        "total_running_patients": 80,
        "total_completed_patients": 50,
        "total_treated_patients": 30
    },
    {
        "Center Name": "Delhi",
        "total_leads": 120,
        "total_appointments": 90,
        "total_new_patients": 25,
        "total_running_patients": 55,
        "total_completed_patients": 25,
        "total_treated_patients": 20
    },
    {
        "Center Name": "Karnataka",
        "total_leads": 180,
        "total_appointments": 140,
        "total_new_patients": 35,
        "total_running_patients": 70,
        "total_completed_patients": 40,
        "total_treated_patients": 25
    },
    {
        "Center Name": "Tamil Nadu",
        "total_leads": 160,
        "total_appointments": 130,
        "total_new_patients": 30,
        "total_running_patients": 65,
        "total_completed_patients": 35,
        "total_treated_patients": 20
    },
    {
        "Center Name": "M.P.",
        "total_leads": 140,
        "total_appointments": 110,
        "total_new_patients": 25,
        "total_running_patients": 55,
        "total_completed_patients": 30,
        "total_treated_patients": 15
    }

]

const CenterWiseLeadsChart = () => {
    // Prepare data for the chart
    const chartData = useMemo(() => {
        const centerNames = data.map(item => item['Center Name'])
        const totalLeads = data.map(item => item.total_leads)
        const totalAppointments = data.map(item => item.total_appointments)
        const totalNewPatients = data.map(item => item.total_new_patients)
        const totalRunningPatients = data.map(item => item.total_running_patients)
        const totalCompletedPatients = data.map(item => item.total_completed_patients)
        const totalTreatedPatients = data.map(item => item.total_treated_patients)

        return {
            centerNames,
            totalLeads,
            totalAppointments,
            totalNewPatients,
            totalRunningPatients,
            totalCompletedPatients,
            totalTreatedPatients
        }
    }, [])

    const colorMap = {
        'Leads': '#487FFF',
        'Appointments': '#45B369',
        'New Patients': '#FF9F43',
        'Running Patients': '#E74C3C',
        'Completed Patients': '#9B59B6',
        'Treated Patients': '#1ABC9C'
    }

    const series = [
        {
            name: 'Leads',
            data: chartData.totalLeads
        },
        {
            name: 'Appointments',
            data: chartData.totalAppointments
        },
        {
            name: 'New Patients',
            data: chartData.totalNewPatients
        },
        {
            name: 'Running Patients',
            data: chartData.totalRunningPatients
        },
        {
            name: 'Completed Patients',
            data: chartData.totalCompletedPatients
        },
        {
            name: 'Treated Patients',
            data: chartData.totalTreatedPatients
        }

    ]

    const options = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true
                }
            },
            zoom: {
                enabled: true
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%',
                borderRadius: 6,
                endingShape: 'rounded',
                dataLabels: {
                    position: 'top'
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + ' leads'
                }
            }
        },
        xaxis: {
            categories: chartData.centerNames,
            labels: {
                style: {
                    fontSize: '12px',
                    fontWeight: 500
                }
            }
        },
        yaxis: {
            title: {
                text: 'Number of Leads',
                style: {
                    fontSize: '15px',
                    fontWeight: 600
                }
            },
            labels: {
                formatter: function (value) {
                    return Math.round(value)
                }
            }
        },
        fill: {
            opacity: 1,
            colors: [colorMap['Leads'], colorMap['Appointments'], colorMap['New Patients'], colorMap['Running Patients'], colorMap['Completed Patients'], colorMap['Treated Patients']]
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: 0
        },
        grid: {
            borderColor: '#D1D5DB',
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        colors: [colorMap['Leads'], colorMap['Appointments'], colorMap['New Patients'], colorMap['Running Patients'], colorMap['Completed Patients'], colorMap['Treated Patients']]
    }

    return (
        <div className="card h-100 p-0">
            {/* <div className="card-header border-bottom bg-base py-16 px-24">
                <h6 className="text-lg fw-semibold mb-0">Center-Wise Leads Summary</h6>
            </div> */}
            <div className="card-body p-24">
                <ReactApexChart 
                    id="centerWiseLeadsChart" 
                    options={options} 
                    series={series} 
                    type="bar" 
                    height={350} 
                />
                
                {/* Color Legend / Identifier */}
                <div className="mt-24 pt-16 border-top">
                    <h6 className="text-sm fw-semibold mb-16">Color Identifier:</h6>
                    <div className="row">
                        {Object.entries(colorMap).map(([label, color], index) => (
                            <div key={index} className="col-md-4 col-sm-6 col-12 mb-12">
                                <div className="d-flex align-items-center">
                                    <div 
                                        className="me-12" 
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: color,
                                            borderRadius: '4px',
                                            flexShrink: 0
                                        }}
                                    ></div>
                                    <span className="text-sm">{label}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CenterWiseLeadsChart
